export default __webpack_public_path__ + "static/media/10.2174e779.png";